import React, { FunctionComponent, memo } from "react";
import { Grid, RadioGroup, FormControlLabel, Radio } from "@mui/material";
import InvestorRequestFormTitle from "@investorRequest/components/InvestorRequestFormTitle";

interface Props {
  value: string;
  onChange(value: string): void;
  disabledOptions?: {
    ach?: boolean;
    fedwire?: boolean;
    swift?: boolean;
  };
}

const PaymentMethodSelector: FunctionComponent<Props> = ({ value, onChange, disabledOptions }) => {
  const isDisabled = (method: "ach" | "fedwire" | "swift"): boolean => !!disabledOptions?.[method];

  const handleSelect = (next: "ach" | "fedwire" | "swift") => {
    if (isDisabled(next)) return; // hard block clicks when disabled
    // No deselect behavior: keep selection stable; just set the chosen method
    if (value !== next) {
      onChange(next);
    }
  };

  return (
    <>
      <InvestorRequestFormTitle text="Payment Method:" />
      <Grid item xs={12}>
        <RadioGroup row value={value || ""} aria-label="payment-method" name="payment-method">
          <FormControlLabel
            value="ach"
            control={<Radio size="small" />}
            label="ACH"
            disabled={!!disabledOptions?.ach}
            onClick={() => handleSelect("ach")}
          />
          <FormControlLabel
            value="fedwire"
            control={<Radio size="small" />}
            label="Fed Wire"
            disabled={!!disabledOptions?.fedwire}
            onClick={() => handleSelect("fedwire")}
          />
          <FormControlLabel
            value="swift"
            control={<Radio size="small" />}
            label="Swift"
            disabled={!!disabledOptions?.swift}
            onClick={() => handleSelect("swift")}
          />
        </RadioGroup>
        {value === "ach" && (
          <div style={{ color: "#99742aff", fontSize: 15, marginTop: 4 }}>
            Please confirm your bank account accepts this payment method.
          </div>
        )}
      </Grid>
    </>
  );
};

export default memo(PaymentMethodSelector);
